import { call, put, takeLatest } from "redux-saga/effects";
import {
  submitEnquiryForm,
  submitEnquiryFormSuccess,
  submitEnquiryFormFailure,
} from "../slices/enquiryFormSlice";

const API_URL = process.env.REACT_APP_BASE_URLL;

const postEnquiryFormAPI = async (formData) => {
  console.log("📦 Sending Data:", formData);

  const res = await fetch(`${API_URL}/enquiry/submit`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  });

  const data = await res.json();

  console.log("📥 Response:", data);

  if (!res.ok) {
    throw new Error(data.message || "Server error");
  }

  return data;
};

function* handleSubmitEnquiryForm(action) {
  try {
    console.log("🔥 ACTION PAYLOAD:", action.payload);

    const response = yield call(postEnquiryFormAPI, action.payload);

    yield put(submitEnquiryFormSuccess(response));
  } catch (error) {
    console.log("❌ API Error:", error.message);

    yield put(submitEnquiryFormFailure(error.message));
  }
}

export function* watchEnquiryFormSaga() {
  yield takeLatest(submitEnquiryForm.type, handleSubmitEnquiryForm);
}
